import React, { useState } from 'react';
import { StickyScroll } from './StickyScroll';

function SkillsScreen() {
  const [skillsBackground, setSkillsBackground] = useState('');

  const content = [
    {
      title: 'The beginnings ',
      description:
        'I started learning HTML, CSS and Javascript in High School by watching programming courses. After a while, I realised that programming would become my passion.',
    },
    {
      title: 'My First Tech/Marketing Job Experience ',
      description: `My first and current job is as a marketing manager of a start-up advertising website.
      My work is entirely based on self-studies, as I have learnt to run Google Ads, Meta Ads, design posts for social media in Figma, analyse data from Google Analytics and code purely by myself.`,
    },
    {
      title: 'First Job as a Developer',
      description:
        'As of July of 2023, I have been working as a Frontend Developer for a Slovak marketing company. My main tasks include creating custom code for existing WordPress websites, testing and debugging these websites. As of November 2023, I have also been developing an app with integrated augmented reality for mobile devices (React Native) and for web (React JS).',
    },
    {
      title: 'New challenges',
      description:
        'I am always ready to face new challenges, to learn and work on my skills. In the future, I plan to dive deeper into programming web applications, mainly backend. If you like my work, do not hesitate to contact me 😀.',
    },
  ];
  return (
    <div
      className='w-screen h-screen px-8'
      style={{ background: skillsBackground }}
    >
      <StickyScroll
        content={content}
        setSkillsBackground={setSkillsBackground}
      />
    </div>
  );
}

export default SkillsScreen;
